"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createErrorsContainer = () => {
    const container = document.createElement('div');
    container.id = 'errors';
    container.style.fontSize = '0.75rem';
    container.style.lineHeight = '1.2em';
    container.style.color = 'red';
    container.style.position = 'absolute';
    container.style.bottom = '0';
    container.style.left = '0';
    container.style.zIndex = '99';
    container.style.cursor = 'pointer';
    document.body.appendChild(container);
    return container;
};
const getErrorsContainer = () => { var _a; return (_a = document.querySelector('#errors')) !== null && _a !== void 0 ? _a : createErrorsContainer(); };
function displayError(message) {
    getErrorsContainer().innerHTML += `<p onclick="this.remove()">${message}</p>`;
}
exports.default = displayError;
